export const types = {
    LOAD_OPTIMIZATION_DATA:"LOAD_OPTIMIZATION_DATA",
    LOAD_OPTIMIZATION_DATA_SUCCESS:"LOAD_OPTIMIZATION_DATA_SUCCESS"
}